module.exports = __webpack_public_path__ + "static/media/English_US_Jennifer BG-14.e741f845.png";